import React from 'react'
import { RadioGroup, RadioGroupItem } from '~/atoms/shadcn/radio-group'
import { Badge } from '~/atoms/shadcn/badge'
import { LlamaAddSquare } from '@easyllama/ui-components/icons'
import { sanitizeHtml } from '~/utils/commonUtils'

export default function ChangePlanPaymentList({ paymentMethods, selectedPaymentId, onChange, onAddPayment }) {
  return (
    <div>
      <p className='text-sm font-semibold text-llama-grey-7 mb-3'>
        3. Select the payment method:
      </p>
      <RadioGroup value={selectedPaymentId} onValueChange={onChange}>
        <div className='border border-llama-grey-8 rounded-[8px]'>
          {paymentMethods?.map((method, index) => (
            <div key={index} className='flex items-center justify-between px-6 py-5 border-b border-llama-grey-8 last:border-b-0'>
              <div className='flex items-center gap-3'>
                <RadioGroupItem
                  value={method.id?.toString()}
                  id={`method-${method.id}`}
                />
                <span dangerouslySetInnerHTML={{ __html: sanitizeHtml(method.brandIcon) }} className='w-9 h-6' />
                <div className='flex items-center gap-10'>
                  <div className='flex items-center gap-1.5 text-sm font-semibold text-llama-grey-7'>
                    <span>{method.brand ? method.brand.charAt(0).toUpperCase() + method.brand.slice(1) : ''}</span>
                    <span className='flex items-center gap-0.5'>
                      <span>(</span>
                      <span className='text-xl tracking-widest leading-none'>•••</span>
                      <span>{method.last4})</span>
                    </span>
                  </div>
                </div>
              </div>
              {method.primary && <Badge className='bg-llama-grey-5'>Default</Badge>}
            </div>
          ))}
        </div>
      </RadioGroup>

      <div
        className='flex items-center gap-1 mt-6 cursor-pointer'
        onClick={onAddPayment}
      >
        <LlamaAddSquare className='size-6 text-llama-grey-10' />
        <div className='text-sm font-bold text-llama-grey-10'>Add Payment Method</div>
      </div>
    </div>
  )
}
